import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from 'ddc-classnames-js';
import trackGa from '../utils/trackEvent';
import { truncateString } from '../utils/truncateString';

export const ReviewContent = ({
	content,
	truncate,
	openModal,
	windowId,
	maxCharacters,
	seeFullReviewBtnAriaLabel,
	showSeeFullReviewBtn,
	seeFullReviewBtnText,
	fontSize,
	seeFullReviewColor
}) => {
	if (!content) return null;

	const truncateContent = (text, maxLength) => {
		if (text.length <= maxLength) {
			return <p>{text}</p>;
		} else {
			const trucatedText = truncateString(text, maxLength);
			return <p>{`${trucatedText}... `}</p>;
		}
	};

	const preserveLineBreaks = (string = '') => {
		const newLineRegex = /(?:\r?\n|\r)/;
		return string
			.trim()
			.split(newLineRegex)
			.reduce((prev, curr) => (
				<React.Fragment>
					{prev}
					<br />
					{curr}
				</React.Fragment>
			));
	};

	const displaySeeFullReviewBtn =
		showSeeFullReviewBtn || content.length > maxCharacters;

	return (
		<div className={setClassNames(['dealer-review-content', fontSize])}>
			{truncate
				? truncateContent(content, maxCharacters)
				: preserveLineBreaks(content)}

			{displaySeeFullReviewBtn && (
				<div>
					<button
						className={`text-link ${
							seeFullReviewColor
								? `text-${seeFullReviewColor}`
								: ''
						}`}
						aria-label={seeFullReviewBtnAriaLabel}
						type="button"
						onClick={() => {
							openModal();
							trackGa(
								windowId,
								'Full review button',
								'Full review shown'
							);
						}}
					>
						{seeFullReviewBtnText}
					</button>
				</div>
			)}
		</div>
	);
};

ReviewContent.propTypes = {
	truncate: PropTypes.bool.isRequired,
	fontSize: PropTypes.string,
	content: PropTypes.string,
	openModal: PropTypes.func,
	windowId: PropTypes.string,
	maxCharacters: PropTypes.number,
	seeFullReviewBtnAriaLabel: PropTypes.string,
	seeFullReviewBtnText: PropTypes.string,
	showSeeFullReviewBtn: PropTypes.bool.isRequired,
	seeFullReviewColor: PropTypes.string
};

ReviewContent.defaultProps = {
	fontSize: ''
};

ReviewContent.defaultProps = {
	openModal: () => '',
	windowId: '',
	content: '',
	maxCharacters: 1,
	seeFullReviewBtnAriaLabel: ''
};
